import posthog from 'posthog-js';

const LEARNER_ROLES = ['AUTH_USER', 'USER_DTC'];
const INTERNAL_EMAIL_DOMAIN = '@accessionhealthtech.com';

// Call this anywhere a user's profile/login info is fetched (login, OTT exchange, profile
// refresh, etc.) so PostHog always has role/email attached to the person, regardless of which
// entry point authenticated them. Safe to call repeatedly — identify()/opt_in/opt_out are
// idempotent, so re-affirming on every profile fetch is how we backfill sessions that started
// before the user was identified.
export default function identifyPosthogUser(userData) {
  if (!userData?.id) return;

  const email = userData.email || userData.emailAddress || '';
  const isInternalUser = email.toLowerCase().endsWith(INTERNAL_EMAIL_DOMAIN);

  if (LEARNER_ROLES.includes(userData.role) && !isInternalUser) {
    posthog.opt_in_capturing();
  } else {
    posthog.opt_out_capturing();
  }
  posthog.identify(String(userData.id), {
    email,
    name: userData.firstName
      ? `${userData.firstName} ${userData.lastName || ''}`.trim()
      : undefined,
    role: userData.role,
  });
}
